import { Grid, Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import {
  ListItemDto,
  PricingParametersApi,
} from "../../../api/PricingPlatformApi.generated";
import PricingRegion from "./PricingRegion";
import { useDispatch, useSelector } from "react-redux";
import BusinessHoursSetting from "components/pages/settings/BusinessHoursSetting";
import { RootState } from "redux/Store";
import { savePricingParameters } from "redux/slices/PricingParameters/pricingParametersSlice";
import {
  request,
  requestFailure,
  requestSuccess,
} from "redux/slices/Shared/sharedSlice";
import { useApiContext } from "contexts/ApiProvider";

const PricingParameters = () => {
  const dispatch = useDispatch();
  const { pricingParametersApi } = useApiContext();

  const equipmentTypes = useSelector(
    (state: any) => state.pricingParametersReducer.equipmentTypes
  );
  const regions = useSelector(
    (state: RootState) => state.pricingParametersReducer.regions
  );

  useEffect(() => {
    dispatch(request());

    pricingParametersApi
      .getPricingParameters()
      .then((response) => {
        dispatch(requestSuccess());
        dispatch(savePricingParameters(response));
      })
      .catch((error) => {
        dispatch(requestFailure(error));
      });
  }, [dispatch, pricingParametersApi]);

  return (
    <Grid item xs={12} width="100%">
      <Paper variant="basePaper">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4">Pricing Parameters</Typography>
          </Grid>
          <Grid item xs={12} ml={2}>
            <Typography variant="body1">
              The following tables display the core pricing parameter buckets
              and their associated markups. These values will be used to
              calculate the base markup for each quote. Markups can be adjusted
              further via the Rules Engine and manual refinements on the Quote
              Details page.
            </Typography>
          </Grid>
          <Grid item xs={12} ml={7}>
            <BusinessHoursSetting></BusinessHoursSetting>
          </Grid>
          {regions?.map((region) =>
            equipmentTypes.map((equipmentType: ListItemDto) => (
              <Grid
                item
                xs={12}
                key={`${region.regionId}-${equipmentType.value}`}
              >
                <PricingRegion region={region} equipmentType={equipmentType} />
              </Grid>
            ))
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default PricingParameters;
